<div [class]="classObj" (click)="close()">
    {{item.message | localize: item.parameter | trimText: options.maxLength}}
</div>